<template>
  <header class="header">
    <nav>
    <router-link to="/" class="header-title">
      <h1>PieChartMaster - Pie/Rose Chart Maker !</h1>
    </router-link>
    <a href="https://apps.apple.com/us/app/piechartmaster-ultimate-pie/id6478547148" target="_blank">👉 AppStore | iPhone/iPad/Mac/VisionPro 🎉</a>    
    <a href="https://studio.piechartmaster.com/"  target="_blank"> Online Pie/Rose Chart Editor !</a>
    <!---
      <ul>
        <li><router-link to="/about">About</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
      </ul>
      --->
    </nav>
  </header>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Header',
};
</script>

<style scoped>
.header {
  background-color: #f8f9fa; /* Light background color */
  padding: 10px 20px; /* Padding for the header */
  text-align: center; /* Center text */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  width: 100%;
}

nav ul {
  text-align: center; /* Center text */
  list-style: none; /* Remove default list styles */
  display: flex; /* Flexbox for horizontal layout */
  gap: 15px; /* Space between items */
}

nav a {
  text-align: center; /* Center text */
  text-decoration: none; /* Remove underline */
  color: #333; /* Text color */
  spacing:18px;
  margin: 5px 10px; /* Horizontal spacing between links */
}

nav a:hover {
  text-decoration: underline; /* Underline on hover */
  color: orange;
}
</style>